export default {
  "hash": "dea69d2",
  "raw": "v3.31.0",
  "semverString": "3.31.0"
};